import { alpha, Theme } from "@mui/material/styles";
import { TachographStatus } from "../models/Tachograph";

/** All tachograph tables offer the same page sizes. */
export const TACHOGRAPH_PAGE_SIZES = [10, 25, 50, 100, 1000];

/** Row class for the readout status; unknown and ok rows stay plain. */
export const dueRowClassName = (status: TachographStatus | undefined): string =>
  status === "overdue" ? "tachograph-row--overdue" : status === "warning" ? "tachograph-row--due-soon" : "";

/** Light red for overdue rows, light yellow for rows due soon; a little stronger on hover. */
export const DUE_ROW_SX = {
  "& .tachograph-row--overdue": {
    backgroundColor: (theme: Theme) => alpha(theme.palette.error.main, 0.12),
    "&:hover": { backgroundColor: (theme: Theme) => alpha(theme.palette.error.main, 0.2) },
  },
  "& .tachograph-row--due-soon": {
    backgroundColor: (theme: Theme) => alpha(theme.palette.warning.main, 0.16),
    "&:hover": { backgroundColor: (theme: Theme) => alpha(theme.palette.warning.main, 0.24) },
  },
};
